import React from 'react';
import { MdEditRoad } from 'react-icons/md';
import { getRiskStyles } from './ui';

const DriverBanner = ({ reportData, scoreData }) => {
  if (!scoreData) return null;

  const riskStyles = getRiskStyles(scoreData?.risk_level);

  return (
    <div className="sticky top-0 left-0 right-0 z-10 mb-2">
      <div className="mx-4 flex items-center justify-between px-4 py-2 mb-2 mt-1 bg-brand-100 border border-brand-200 rounded-md shadow-sm backdrop-blur-sm bg-opacity-95">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <MdEditRoad className="text-brand-600" />
            <span className="font-medium text-neutral-900">
              {reportData?.driving_record?.["driver"]["full_name"]}
            </span>
          </div>
          <span className="text-neutral-500 text-[11px] bg-neutral-50 px-2 py-0.5 rounded-md border border-neutral-200">
            License:{" "}
            {reportData?.driving_record?.["license"]["license_number"]}
          </span>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-neutral-50 px-2 py-1 rounded-md border border-neutral-200">
            <span className="text-[11px] text-neutral-500">Risk:</span>
            <span className={`text-[11px] font-medium ${riskStyles.text}`}>
              {scoreData?.risk_level || "Moderate"}
            </span>
          </div>
          <div className="flex items-center gap-2 bg-neutral-50 px-2 py-1 rounded-md border border-neutral-200">
            <span className="text-[11px] text-neutral-500">Score:</span>
            <span className="text-[11px] font-medium text-neutral-900">
              {scoreData?.score || "25"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverBanner;